
import { cn } from "@/lib/utils";

type UnsplashAttributionProps = {
  photographerName: string;
  photographerUsername: string;
  photographerUrl: string;
  unsplashUrl: string;
  className?: string;
};

export function UnsplashAttribution({
  photographerName,
  photographerUrl,
  unsplashUrl,
  className,
}: UnsplashAttributionProps) {
  return (
    <div className={cn("text-xs text-slate-500", className)}>
      Photo by{" "}
      <a
        href={photographerUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-slate-700"
      >
        {photographerName}
      </a>{" "}
      on{" "}
      <a
        href={unsplashUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="underline hover:text-slate-700"
      >
        Unsplash
      </a>
    </div>
  );
}

type UnsplashImageProps = {
  url: string;
  alt: string;
  attribution: {
    photographerName: string;
    photographerUsername: string;
    photographerUrl: string;
    unsplashUrl: string;
  };
  className?: string;
  imageClassName?: string;
  captionClassName?: string;
};

export function UnsplashImage({
  url,
  alt,
  attribution,
  className,
  imageClassName,
  captionClassName,
}: UnsplashImageProps) {
  return (
    <figure className={cn("my-4", className)}>
      <div className="overflow-hidden rounded-lg">
        <img
          src={url}
          alt={alt}
          className={cn("w-full h-auto object-cover", imageClassName)}
        />
      </div>
      
      <figcaption className={cn("mt-2 text-center", captionClassName)}>
        <UnsplashAttribution
          photographerName={attribution.photographerName}
          photographerUsername={attribution.photographerUsername}
          photographerUrl={attribution.photographerUrl}
          unsplashUrl={attribution.unsplashUrl}
        />
      </figcaption>
    </figure>
  );
}
